
import { Component, Vue, Prop } from 'vue-property-decorator'
import StreakEventBarItem from '~/components/gamification/StreakEventBarItem.vue'
import { Streak } from '~/types/store'

@Component({
  components: {
    StreakEventBarItem
  }
})
export default class StreakEventBar extends Vue {
  @Prop({ type: Array, default: [] }) statuses!: Streak.StreakEvent[]
  @Prop({ type: Array, default: [] }) appliedOf!: number[]
  @Prop({ type: Number, default: 0 }) sequence!: number
}
